/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React from "react";
import {
  Collapse,
  createStyles,
  fade,
  Theme,
  withStyles,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { TreeItem, TreeItemProps } from "@material-ui/lab";
import { animated, useSpring } from "react-spring";
import { PathLabeledCheckbox } from "./PathLabeledCheckbox";
import { PathCheckboxTreeDefs, PathCheckboxTreeData } from "../../types";

function TransitionComponent(props: TransitionProps) {
  const style = useSpring({
    from: { opacity: 0, transform: "translate3d(20px,0,0)" },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

interface Props extends TreeItemProps {
  value: string;
  data: PathCheckboxTreeData;
  defs: PathCheckboxTreeDefs;
  indeterminate?: boolean;
  disabled?: boolean;
  handleChange: (newData: PathCheckboxTreeData) => void;
}

/** パスチェックボックスツリーアイテム */
export const PathCheckboxTreeItem = withStyles((theme: Theme) =>
  createStyles({
    iconContainer: {
      "& .close": {
        opacity: 0.3,
      },
    },
    group: {
      marginLeft: 7,
      paddingLeft: 18,
      borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
    },
  })
)((props: Props) => {
  const { nodeId, value, label, data, defs, handleChange, children } = props;

  //--------------------
  // コンポーネント
  return (
    <TreeItem
      classes={props.classes}
      nodeId={nodeId}
      // {...props}
      TransitionComponent={TransitionComponent}
      label={(
        <PathLabeledCheckbox
          nodeId={nodeId}
          value={value}
          label={label}
          data={data}
          defs={defs}
          handleChange={handleChange}
        />
    )}
    >
      {children}
    </TreeItem>
  );
});
